import React, { useEffect, useState } from 'react';
import { Box, Tab } from '@mui/material';
import { BoxProps } from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { a11yProps } from 'shared/constants/mui-constants';
import { TabData } from 'shared/types/common.interface';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabsComponentContainer } from '../TabsComponentContainer/TabsComponentContainer';

interface TabsComponentProps extends BoxProps {
  components: TabData[];
}

export const TabsComponent: React.FunctionComponent<TabsComponentProps> = ({
  components,
  className,
  ...props
}) => {
  const [tabValue, setTabValue] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    if (components[newValue]?.path) navigate(components[newValue].path);
  };

  useEffect(() => {
    const hasPathProperty = components.some((tab) => 'path' in tab);
    if (hasPathProperty) {
      const tabIndex = components.findIndex((tab) => tab.path === location.pathname);

      if (tabIndex !== -1) {
        setTabValue(tabIndex);
      }
    }
  }, [components, location]);

  return (
    <>
      <Box width="100%" height="32px" position="relative" {...props}>
        <Tabs
          className={`modal ${className}`}
          orientation="horizontal"
          variant="fullWidth"
          value={tabValue}
          onChange={handleChange}
          aria-label="modal tabs"
        >
          {components?.map((item: TabData, index: number) => (
            <Tab key={index} label={item.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {components?.map((item: TabData, index: number) => (
        <TabsComponentContainer key={index} value={tabValue} index={index}>
          {item.component}
        </TabsComponentContainer>
      ))}
    </>
  );
};

export default TabsComponent;
